import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 3,
					y: 11,
					width: 18,
					height: 2,
					rx: .95
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 3,
					y: 16,
					width: 18,
					height: 2,
					rx: .95
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 3,
					y: 6,
					width: 18,
					height: 2,
					rx: .95
				})
			]
		})
	})
});
export { SvgMenu as ReactComponent };
